import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

import { UserService } from '@app/services';
import { AnalyticsService } from '@app/services/analytics/analytics.service';

@Component({
   selector: 'mnf-modal-not-balance',
   templateUrl: './modal-not-balance.component.html',
   styleUrls: ['./modal-not-balance.component.scss']
})
export class ModalNotBalanceComponent implements OnInit {

   @ViewChild("modalControl") modalControl: ElementRef;

   user: any;
   stp: any;

   name = '';

   balanceNeeded: number;
   participationsToPurchase: number;
   devName: string;

   constructor(
      private userServ: UserService, private dialog: MatDialogRef<ModalNotBalanceComponent>, private toastr: ToastrService,
      private analyticsService: AnalyticsService,
   ) { }

   ngOnInit(): void {
      this.userServ.getUserInf().subscribe(r => {
         this.user = r;
         const motherSurname = r.motherSurname ? ' ' + r.motherSurname : '';
         this.name = r.name + ' ' + r.fatherSurname + motherSurname;

         this.stp = r.wallet;
      })
   }

   copyClabe() {
      const el = document.createElement('textarea');  // Create a <textarea> element
      el.value = this.stp.clabe;                                 // Set its value to the string that you want copied
      el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
      el.style.position = 'absolute';
      el.style.left = '-9999px';                      // Move outside the screen to make it invisible
      document.body.appendChild(el);                  // Append the <textarea> element to the HTML document

      const selected =
         (document.getSelection()?.rangeCount || 0) > 0        // Check if there is any content selected previously
            ? document.getSelection()?.getRangeAt(0)     // Store selection if found
            : 0;                                    // Mark as false to know no selection existed before
      el.select();                                    // Select the <textarea> content
      document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)

      this.toastr.success('Se ha copiado correctamente su cuenta clabe.');

      document.body.removeChild(el);                  // Remove the <textarea> element

      if (selected) {                                 // If a selection existed before copying
         document.getSelection()?.removeAllRanges();    // Unselect everything on the HTML document
         document.getSelection()?.addRange(selected);   // Restore the original selection
      }
   }

   /** Cerrar modal si no ha abonado a su cuenta */
   closeModal() {
      this.analyticsService.pushEvent('likely_purchase_participation', { status: 'CANCEL_RECHARGE' });
      this.dialog.close();
   }

   /** Función para recargar la página */
   reloadPage() {
      this.analyticsService.pushEvent('likely_purchase_participation', { status: 'ALREADY_RECHARGE' });
      this.dialog.close('reload');
   }

}
